module.exports = __webpack_public_path__ + "img/img20.331bab8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img20.jpg
// module id = 317
// module chunks = 0